<template>
  <section class="skills main-layout full">
    <p>Programming in modern JavaScript (ES6)</p>
    <p class="headline">JS Frameworks:<span> Vue.js, Angular, React </span></p>
    <p class="headline">State Management:<span> Vuex, Ngrx, Redux </span></p>
    <p>HTML5, CSS3, SASS, Responsive design</p>
    <p class="headline">Server side: <span> Node.js </span></p>
    <p class="headline">
      Database management: <span> MongoDB & Atlas, SQL </span>
    </p>
  </section>
</template>

<script>
export default {
  name: 'skills',
};
</script>
